(function () {
  var footer = document.querySelector(".site-footer");
  var floatingBar = document.querySelector(".product-floating-bar");

  if (!footer || !floatingBar) {
    return;
  }

  var ticking = false;

  function updateFloatingBarVisibility() {
    ticking = false;

    var footerTop = footer.getBoundingClientRect().top;
    var shouldHide = footerTop <= window.innerHeight;

    floatingBar.classList.toggle("is-footer-hidden", shouldHide);
  }

  function onScrollOrResize() {
    if (ticking) {
      return;
    }

    ticking = true;
    window.requestAnimationFrame(updateFloatingBarVisibility);
  }

  window.addEventListener("scroll", onScrollOrResize, { passive: true });
  window.addEventListener("resize", onScrollOrResize);
  window.addEventListener("load", updateFloatingBarVisibility);

  updateFloatingBarVisibility();
})();
